import { JSX } from 'react';
import Slider, { Settings } from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './slick-font-override.css';

const SlickSliderWrapper = (
  props: JSX.IntrinsicAttributes &
    JSX.IntrinsicClassAttributes<Slider> &
    Readonly<Settings>
) => {
  return <Slider {...props} />;
};

export default SlickSliderWrapper;
